/**
 * Menghitung persentase down payment (DP) terhadap total tagihan/rate.
 * Persentase ini bisa melebihi 100% jika jumlah DP lebih besar dari total tagihan.
 *
 * @param {object} params - Objek yang berisi data pembayaran.
 * @param {number | string | null | undefined} params.total_rate - Total tagihan yang menjadi acuan 100%.
 * @param {number | string | null | undefined} params.down_payment - Jumlah uang muka yang dibayarkan.
 * @returns {number} - Persentase DP, dibulatkan ke bilangan bulat terdekat. Bisa lebih dari 100.
 */
export const getDownPaymentPercentage = ({
    total_rate,
    down_payment,
}: {
    total_rate: number | string | null | undefined;
    down_payment: number | string | null | undefined;
}) => {
    // 1. Konversi input menjadi angka dan tangani nilai null/undefined.
    // Jika input tidak valid, akan menjadi 0.
    const totalRateNum = Number(total_rate) || 0;
    const downPaymentNum = Number(down_payment) || 0;

    // 2. Jika tidak ada total tagihan, maka persentase adalah 0%
    // untuk menghindari pembagian dengan nol.
    if (totalRateNum <= 0) {
        return 0;
    }

    // 3. Hitung persentase mentah.
    // Logikanya berubah: kini kita langsung membandingkan down_payment dengan total_rate.
    const rawPercentage = (downPaymentNum / totalRateNum) * 100;

    // 4. Bulatkan hasil. Batasan 100% (Math.min) telah dihapus.
    // Math.max(0, ...) tetap digunakan untuk memastikan tidak ada hasil negatif.
    const finalPercentage = Math.max(0, rawPercentage);

    return Math.round(finalPercentage);
};